if (!customElements.get('drv-scale')) {
  customElements.define(
    'drv-scale',
    class DrvScale extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.drv-scale__input');
        if (!this.input) return;
        const data = this.querySelector('script[type="application/json"]');
        this.steps = data ? JSON.parse(data.textContent) : [];
        this.titleEl = this.querySelector('[data-drv-scale-title]');
        this.textEl = this.querySelector('[data-drv-scale-text]');
        this.input.addEventListener('input', () => this.update());
        this.update();
      }

      update() {
        const step = this.steps[Number(this.input.value)] || {};
        if (this.titleEl) {
          this.titleEl.textContent = step.title || '';
          this.titleEl.hidden = !step.title;
        }
        if (this.textEl) {
          this.textEl.textContent = step.text || '';
          this.textEl.hidden = !step.text;
        }
        const valueText = [step.label, step.title, step.text].filter(Boolean).join(', ');
        if (valueText) this.input.setAttribute('aria-valuetext', valueText);
      }
    }
  );
}
